import { requestConfig } from '@altenar/transport'

const origins = {
  // web: '//hybrid-clientapi-altenar-dev.biahosted.com/',
  // betting: '//sb1betslip-altenar-dev.biahosted.com/',
  // config: '//hybrid-frontend-altenar-dev.biahosted.com/',
  // auth: '//hybrid-frontend-altenar-dev.biahosted.com/'
  auth: 'https://sb1client-altenar-stage.biahosted.com/',
  betslip: 'https://sb1betslipapi-altenar-stage.biahosted.com/api/',
  betting: 'https://sb1betslipapi-altenar-stage.biahosted.com/',
  config: 'https://sb1client-altenar-stage.biahosted.com/',
  eventDetails: 'https://sb1capi-altenar-stage.biahosted.com/',
  web: 'https://sb1capi-altenar-stage.biahosted.com/',
  coupon: ''
}

export function extendOrigins(params) {
  for (const prop of Object.keys(params)) {
    const splittedProp = String(prop).split('Origin')[0]
    if (origins[splittedProp]) {
      origins[splittedProp] = params[prop]
    }
  }
  requestConfig.origins = origins
}

export default origins
